import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import { SelectMenuOption } from "../../../../form/select-menu/select-menu.component";
import { TranslationService } from "../../../../_services/translation.service";
import { ITranslations } from "../../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { ChildObjectForEdit } from "../user-management-search-box/user-management-search-box.component";
import { GeneralRowEvent } from "../../../../_models/general-row-event";
import { UserManagementService } from "../../../../_services/user-management.service";
import { DateRangeSelectComponent } from "../../../../common/date-range-select/date-range-select.component";
import { EventSerializerService } from "../../../../_services/eventsServices/eventSerializer.service";
import { SelectOrgansComponent } from "../../../../common/select-organs/select-organs.component";
import { SessionManagerService } from "../../../../_services/SessionManager/session-manager.service";

@Component({
  selector: "user-management-search",
  templateUrl: "./user-management-search.component.html",

  styleUrls: ["./user-management-search.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          height: "100px",
          maxHeight: "230px",
          overflow: "visible",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class UsersManagementSearchComponent {
  @ViewChild("componentMain") public componentMain: ElementRef;
  @ViewChild("selectOrgansComponent")
  public selectOrgansComponent: SelectOrgansComponent;
  @ViewChild("dateRangePicker")
  public dateRangePicker: DateRangeSelectComponent;
  @Output("searchSectionEvent") public searchSectionEvent: EventEmitter<
    GeneralRowEvent<any>
  > = new EventEmitter<GeneralRowEvent<any>>();
  @Output("open-upload-file") public openUploadFileModal: EventEmitter<null> =
    new EventEmitter<null>();
  public advanceSearchOpen: boolean = false;

  public eventsTypeSelectMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "OnlyActive",
      text: "משתמשים פעילים בלבד",
      customValue: "",
    },

    {
      icon: "",
      key: "OnlyNonActive",
      text: "משתמשים לא פעילים בלבד",
      customValue: "",
    },
    {
      icon: "",
      key: "allUserTypes",
      text: "כל המשתמשים",
      customValue: "",
    },
  ];
  public EventTypeSelect: SelectMenuOption =
    this.eventsTypeSelectMenuOptions[0];
  public searchBoxValue: string = "";

  public translations$: Observable<ITranslations>;

  constructor(
    private translationService: TranslationService,
    private userManagementService: UserManagementService,
    public sessionManagerService: SessionManagerService
  ) {
    this.getCurrentYear().then();
    this.translations$ = this.translationService.translations;
    this.advanceSearchOpen = this.sessionManagerService.isDevModeActive();
  }

  public get advancedSearchFeatureActive(): boolean {
    return true;
  }

  public async getCurrentYear() {}

  public openAdvanced() {
    this.advanceSearchOpen = !this.advanceSearchOpen;
  }

  public setEventTypeSelect($event: SelectMenuOption) {}

  public basicSearch() {
    const search = this.searchBoxValue;

    this.userManagementService
      .searchUser({ search, searchType: "standard" })
      .then();
  }

  public submitAdvancedSearch() {
    const selectedNests = this.selectOrgansComponent.getSelectedOrgans() || [];

    const kehilot = selectedNests
      .filter((k) => k.type === "circle")
      .map((k) => +k.id);
    const kenim = selectedNests
      .filter((k) => k.type === "nest")
      .map((k) => +k.id);
    const mehozot = selectedNests
      .filter((c) => c.type === "county")
      .map((k) => +k.id);
    const { dateTo, dateFrom } = this.dateRangePicker;
    const eventType = this.EventTypeSelect;
    const usersEntryDateFrom = dateFrom
      ? EventSerializerService.dateToEpoc(dateFrom).toString()
      : null;
    const usersEntryDateTo = dateTo
      ? EventSerializerService.dateToEpoc(dateTo).toString()
      : null;
    this.userManagementService
      .searchUser({
        search: this.searchBoxValue,
        searchType: "advanced",
        kehilot,
        kenim,
        mehozot,
        from_date: usersEntryDateFrom === "0" ? null : usersEntryDateFrom,
        to_date: usersEntryDateTo === "0" ? null : usersEntryDateTo,
        is_active:
          eventType.key === "OnlyActive"
            ? true
            : eventType.key === "OnlyNonActive"
            ? false
            : null,
      })
      .then();
  }

  public openUploadExcelFileModal() {
    this.openUploadFileModal.emit();
  }

  public userSelectedFromSearchBox($event: ChildObjectForEdit) {
    const child = $event as any;
    let action = "editActivityFields";
    if (child.canEditPermissionLevel === "edit_details") {
      action = "edit";
    }
    this.searchSectionEvent.emit({
      eventId: $event.id.toString(),
      eventObject: $event,
      action: action as any,
    });
  }

  public updateSearchResults(event: string) {
    this.searchBoxValue = event;
  }

  public executeSearch() {
    this.basicSearch();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-page/user-management-search/user-management-search.component.ts